export default function RAirplayButton() {
  throw new Error("not implemented on web.");
}
